import { IPostalcode, SearchPayload, UpdateValueType } from "./type";
import { IPostalcodeSearch, IParentElementPostalCode } from "./type";
import { IUseFetchDetailError } from "@/hook/fetch/interface";
import { IStore } from "../../types/StoreType";
import { useFetch } from "@/hook/fetch/fetch";
import { store } from "@/store";
import { Module } from "vuex";
import { SearcInputType } from "../GeoPlace/type";
import { ChedulesDetails } from "../accountDetails/type";
import { ref } from "vue";

export const PostalCodeModuleOperation: Module<IPostalcode, IStore> = {
  state: {
    country: {
      count: null,
      next: null,
      previous: null,
      isLoading: true,
      isError: false,
      results: null,
      select: null,
      options: null,
    },
    region: {
      count: null,
      next: null,
      previous: null,
      isLoading: true,
      isError: false,
      results: [],
      select: null,
      options: [],
    },
    city: {
      count: null,
      next: null,
      previous: null,
      isLoading: true,
      isError: false,
      results: [],
      select: null,
      options: [],
    },
    postalcode: {
      count: null,
      next: null,
      previous: null,
      isLoading: true,
      isError: false,
      results: [],
      select: null,
      options: [],
    },
  },
  getters: {
    getAllDataPostalCode(state) {
      return state;
    },
    getCountryPostalcodeOptions(state) {
      return {
        data: state.country.results,
        loading: state.country.isLoading,
      };
    },
    getRegionPostalcodeOptions(state) {
      let filter = state.region.results || [];
      if (state.postalcode.results && state.postalcode.results?.length > 0)
        filter =
          state.region.results?.filter((region) =>
            state.postalcode.results?.some(
              (postalcode) => postalcode.geo_region === region.name
            )
          ) || [];
      if (state.postalcode.select?.data?.geo_region)
        filter =
          state.region.results?.filter(
            (region) =>
              region.name === state.postalcode.select?.data?.geo_region
          ) || [];

      return {
        data: filter.length <= 0 ? state.region.results : filter,
        loading: state.region.isLoading,
      };
    },
    getCityPostalcodeOptions(state): {
      data: SearcInputType[];
      loading: boolean;
    } {
      const update = () => {
        const initialValues = ref<ChedulesDetails>(
          store.getters.getChedulesComponentValuesAccountDetails
        );
        console.log(          store.getters.getRegionStockPostalcodeOptions.data.length <= 0 &&
          (!store.getters.getCityStockSelectPostalCode?.value ||
            !store.getters.getRegionStockSelectPostalCode?.name) &&
          (!initialValues.value.region_stock || !initialValues.value.city_stock))
        if (
          store.getters.getRegionStockPostalcodeOptions.data.length <= 0 &&
          (!store.getters.getCityStockSelectPostalCode?.value ||
            !store.getters.getRegionStockSelectPostalCode?.name) &&
          (!initialValues.value.region_stock || !initialValues.value.city_stock)
        ) {
          store.commit("updateChedulesLocationValues");
        }
      };
      if (
        !state.postalcode?.results ||
        state.postalcode?.results?.length <= 0
      ) {
        update();
        return { data: [], loading: false };
      }

      if (state.postalcode?.results.length === 1) {
        update();
        return {
          data: state.postalcode?.results.map((_) => {
            return {
              id: _.id,
              value: _.geo_name,
              data: _,
            };
          }),
          loading: state.postalcode.isLoading,
        };
      }

      let data = state.postalcode?.results
        .map((_) => {
          return {
            id: _.id,
            value: _.geo_name,
            data: _,
          };
        })
        .filter(
          (v, i, a) =>
            a.findIndex((v2) => v2.data.geo_name === v.data.geo_name) === i
        );

      if (state.region.select?.name)
        data = data.filter(
          (city) => city.data.geo_region === state.region.select?.name
        );
      if (state.postalcode.select)
        data = data.filter(
          (city) =>
            city.data.geo_name === state.postalcode.select?.data?.geo_name
        );
      update();

      return { data, loading: state.postalcode.isLoading };
    },
    getPostalcodePostalcodeOptions(state) {
      if (!state.postalcode?.results || state.postalcode?.results?.length <= 0)
        return { data: [], loading: false };

      const data = state.postalcode?.results.map((_) => {
        return {
          id: _.id,
          value: _.postal_code,
          data: _,
        };
      });

      return { data, loading: state.postalcode.isLoading };
    },
    getCountrySelectPostalCode(state) {
      return state.country.select;
    },
    getRegionSelectPostalCode(state) {
      return state.region.select;
    },
    getCitySelectPostalCode(state) {
      return state.city.select;
    },
    getPostalcodeSelectPostalCode(state) {
      return state.postalcode.select;
    },
  },
  mutations: {
    copyAddressInPostalcodeStock(state) {
      store.commit("updateChedulesLocationValues");
      store.commit("updateCopyPostalcodeValues", { ...state });
    },
    updateCountryResult(
      state,
      payload: UpdateValueType<IParentElementPostalCode>
    ) {
      state.country.results = payload.data.results;
      state.country.isLoading = payload.loading;
    },
    updateRegionResult(
      state,
      payload: UpdateValueType<IParentElementPostalCode>
    ) {
      state.region.results = payload.data.results;
      state.region.isLoading = payload.loading;
    },
    updateCityResult(state, payload: UpdateValueType<IPostalcodeSearch>) {
      state.city.results = payload.data.results;
      state.city.isLoading = payload.loading;
    },
    updatePostalcodeResult(state, payload: UpdateValueType<IPostalcodeSearch>) {
      state.postalcode.results = payload.data.results;
      state.postalcode.isLoading = payload.loading;
    },
    updateCountrySelectPostalCode(state, payload) {
      state.country.isLoading = false;
      state.country.select = payload;

      state.city.results = [];
      state.city.select = null;

      state.region.results = [];
      state.region.select = null;

      state.postalcode.results = [];
      state.postalcode.select = null;
    },
    updateRegionSelectPostalCode(state, payload) {
      state.region.isLoading = false;
      state.region.select = payload;
    },
    updateCitySelectPostalCode(state, payload) {
      state.city.isLoading = false;
      if (Array.isArray(payload)) state.city.select = payload[0];
      else state.city.select = payload;
    },
    updatePostalcodeSelectPostalCode(state, payload) {
      state.postalcode.isLoading = false;
      if (Array.isArray(payload)) state.postalcode.select = payload[0];
      else state.postalcode.select = payload;

      store.commit("changeSelectedCountryPostalCode", state.postalcode.select);
    },
    changeSelectedPostalCodePostalCode(state, payload) {
      if (state.postalcode?.select) state.postalcode.select.value = payload;
    },
    changeSelectedCountryPostalCode(
      state,
      payload: SearcInputType | null | undefined
    ) {
      state.country.select = state.country.results?.find(
        (country) => country.name === payload?.data?.geo_country
      );
      if (state.country.select && state.country.select?.name) {
        const filter = state.country.results?.find(
          (country) => country.name !== state.country.select?.name
        );
        if (filter) {
          state.country.results = [state.country.select, filter];
        }
        return;
      }

      state.country.select = state.country.results?.find(
        (country) =>
          country.name ===
          store.getters?.getPersonalDataComponenValuesAccountDetails.country
      );
      if (state.country.select) {
        const filter = state.country.results?.find(
          (country) => country.name !== state.country.select?.name
        );
        if (filter) {
          state.country.results = [state.country.select, filter];
        }
        return;
      }
    },
  },
  actions: {
    async getCountryPostalcode({ commit, state }) {
      state.country.isLoading = true;

      const { data, isError, isLoading } = await useFetch<
        IParentElementPostalCode,
        IUseFetchDetailError
      >(process.env.VUE_APP_SERVER + "api/geo_place/?level=1", "GET", true);

      if (
        !isError.value &&
        data.value &&
        data.value.count &&
        data.value.count > 0
      ) {
        commit("updateCountryResult", {
          data: data.value,
          loading: isLoading.value,
        });
        commit("changeSelectedCountryPostalCode");
        store.commit("updatePersonalDataComponenValuesAccountDetails");
      }
    },
    async getRegionPostalcode({ commit, state }) {
      state.region.isLoading = true;

      let url = process.env.VUE_APP_SERVER + "api/geo_place/?level=2";

      if (state.country.select?.name)
        url += "&country=" + state.country.select?.name;

      const { data, isError, isLoading } = await useFetch<
        IParentElementPostalCode,
        IUseFetchDetailError
      >(url, "GET", true);

      if (
        !isError.value &&
        data.value &&
        data.value.count &&
        data.value.count > 0
      )
        commit("updateRegionResult", {
          data: data.value,
          loading: isLoading.value,
        });
    },
    async getCityPostalcode({ commit, state }) {
      state.region.isLoading = true;

      let url =
        process.env.VUE_APP_SERVER + "api/postal_codes/?geo_place__level=3";

      if (state.region.select?.name)
        url += "&geo_region=" + state.region.select?.name;
      if (state.country.select?.name)
        url += "&geo_country=" + state.country.select?.name;

      const { data, isError, isLoading } = await useFetch<
        IPostalcodeSearch,
        IUseFetchDetailError
      >(url, "GET", true);

      if (
        !isError.value &&
        data.value &&
        data.value.count &&
        data.value.count > 0
      )
        commit("updatePostalcodeResult", {
          data: data.value,
          loading: isLoading.value,
        });
    },
    async getPostalcodePostalcode(
      { commit, dispatch, state },
      payload: SearchPayload
    ) {
      state.region.isLoading = true;

      let url =
        process.env.VUE_APP_SERVER + "api/postal_codes/?geo_place__level=3";

      if (state.country.select?.name)
        url += "&geo_country=" + state.country.select?.name;
      if (payload?.value && payload?.value?.length > 0)
        url += "&postal_code__startswith=" + payload.value;

      const { data, isError, isLoading } = await useFetch<
        IPostalcodeSearch,
        IUseFetchDetailError
      >(url, "GET", true);

      if (
        !isError.value &&
        data.value &&
        data.value.count &&
        data.value.count > 0
      ) {
        commit("updatePostalcodeResult", {
          data: data.value,
          loading: isLoading.value,
        });
        commit("changeSelectedPostalCodePostalCode", payload.value);

        await dispatch("getRegionPostalcode");
      }
    },
  },
};
